import React from 'react';
import { Toaster } from 'react-hot-toast';
function App() {
  return (
    <>       
      <h1> Add Block IP </h1>    
      <Toaster position="top-center" />
    </>
  );
}

export default App;
